import Grid from "@material-ui/core/Grid";
import Button from "../Button/Button";
import React from "react";
import classes from "./ButtonsStrip.module.css";
import Popup from "../Popup/Popup";
import MailingPopup from "../../CVs/CvDetails/MailingPopup/MailingPopup";

let spaceOut = (v,rightButtons,leftButtons) => {
    let allButtons = leftButtons.concat(rightButtons)

    allButtons.map (b => {
        b.isVisible && v--
        return v
    })
    return v
}

let Element = (props) => {

    let showButtons = (buttons) => {
        return buttons.map ((b,index) => b.isVisible &&
            <Grid key={index}
                item
                xs
                className={ classes.btnGrid }>
                <Button lang={ props.lang } { ...b }/>
                { b.popup && <Popup lang={ props.lang } { ...b.popup } /> }
                { b.hasMailingPopup &&
                <MailingPopup { ...props.mailingPopup } dict={ props.dict } lang={ props.lang } actionBtnName={ b.label }
                              isOpenPopup={ props.mailingPopup.openPopup === b.label }/> }
            </Grid>
        )
    }

    return (
        <Grid container
              className={props.isOpenOpportunityDrawer ? classes.btnOpportunityContainer : classes.btnOpenCvContainer}
              style={props.maxWidth}>
            {props.buttons && showButtons(props.buttons)}
            <Grid item
                  xs={spaceOut(10, props.rightButtons ? props.rightButtons : [], props.buttons ? props.buttons : [])}
            />
            {props.rightButtons && showButtons(props.rightButtons)}
            {props.popup ? <Popup {...props.popup} lang={props.lang}/> : null}
        </Grid>
    )
}

export default Element;